export enum YoutubeItemType {
  VIDEO = 'youtube#video',
  CHANNEL = 'youtube#channel',
  PLAYLIST = 'youtube#playlist'
}

export interface YoutubeChannel {
  id: string;
  title: string;
  description: string;
  imageUrl: string;
  itemType: YoutubeItemType;
}

export interface YoutubeVideo {
  id: string;
  title: string;
  imageUrl: string;
  channelId: string;
  channelTitle: string;
  itemType: YoutubeItemType;
  captionsAvailable: boolean;
}

export interface YoutubePlaylist {
  id: string;
  title: string;
  description: string;
  imageUrl: string;
  channelId: string;
  channelTitle: string;
  itemType: YoutubeItemType;
  videos: YoutubeVideo[];
}

export interface YoutubeSearchResult {
  items: (YoutubeVideo | YoutubeChannel | YoutubePlaylist)[];
  searchQuery: string;
  nextPageToken?: string;
}

export interface YoutubeChannelVideosResult {
  videos: YoutubeVideo[];
  channelId: string;
  nextPageToken?: string;
}

export interface YoutubePlaylistVideosResult {
  videos: YoutubeVideo[];
  playlistId: string;
  nextPageToken?: string;
}

export interface YoutubeSearchQuery {
  query: string;
  nextPageToken?: string;
}

export interface YoutubeChannelVideosQuery {
  channelId: string;
  nextPageToken?: string;
}

export interface YoutubePlaylistVideosQuery {
  playlistId: string;
  nextPageToken?: string;
}

export enum RecommendationType {
  PODCAST = 'PODCAST',
  EDUCATIONAL = 'EDUCATIONAL',
  COMPANY_CONTENT = 'COMPANY_CONTENT',
  PRODUCT_CONTENT = 'PRODUCT_CONTENT',
  EARNINGS_CALL = 'EARNINGS_CALL'
}

export type RecommendationTab = {
  recommendationType: RecommendationType;
  tabName: string;
  videos: YoutubeVideo[];
};
